import { Card } from "../Card";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import StripeConnectLogoSrc from "assets/icons/stripe.png";
import { GatedContentStatus } from "store/stripeConnectAccount/types";
import { useMemo } from "react";
import { StripeAccountsDetails } from "@switcherstudio/switcher-api-client";

export interface IsSetupStateProps {
    link: string;
    target: string;
    details: StripeAccountsDetails;
    gatedContentStatus: GatedContentStatus;
}

export const IsSetupState: React.FC<IsSetupStateProps> = ({
    link,
    target,
    details,
    gatedContentStatus
}) => {
    const { t } = useTranslation();

    const statusText = useMemo(() => {
        if (
            gatedContentStatus === GatedContentStatus.STRIPE_ACCOUNT_UNVERIFIED
        ) {
            return t("video-player-settings:verify-stripe-no-link");
        }
        return null;
    }, [gatedContentStatus, t]);

    return (
        <Card className={styles["container"]}>
            <img
                src={StripeConnectLogoSrc}
                alt="Stripe Connect Logo"
                className={styles["logo"]}
            />
            <div>
                <h5 className={styles["card-header"]}>
                    {details?.Name ?? t("gated-content:stripe-connect-account")}
                </h5>
                <p className={styles["email"]}>{details?.Email}</p>
                {statusText && (
                    <Card position="foreground">
                        <p className={styles["text"]}>{statusText}</p>
                    </Card>
                )}
                <Link to={link} target={target} className={styles["link"]}>
                    {t("gated-content:manage-stripe-account")}
                </Link>
            </div>
        </Card>
    );
};
